import { mutatorAction } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { Dialog } from '@metaos/hub-sdk';
import { taskModules } from '../store/taskModule';
import { InstanceStore } from '../store/schema/TaskModuleInstances';
import { DialogMap } from '../store/schema/TaskModule';

function registerAction(name: string, callback: (store: InstanceStore, ...args: any[]) => void) {
    return (id: string) =>
        mutatorAction(`${name}_${id}`, function (...args) {
            const store = taskModules().instances.get(id);
            if (store) {
                callback(store, ...args);
            }
        });
}

export const registerOpenDialog = registerAction('OPEN_TASK_MODULE', (store: InstanceStore) => {
    store().isOpen = true;
});

export const registerCloseDialog = registerAction('CLOSE_TASK_MODULE', (store: InstanceStore) => {
    store().isOpen = false;
    store().dialogInfo = new ObservableMap() as DialogMap;
});

export const registerUpdateDialog = registerAction(
    'UPDATE_TASK_MODULE',
    (store: InstanceStore, dialogInfo: Partial<Dialog>) => {
        for (let [key, value] of Object.entries(dialogInfo)) {
            store().dialogInfo.set(key, value);
        }
    }
);
